"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DateFormat", {
    enumerable: true,
    get: function() {
        return DateFormat;
    }
});
const _interop_require_default = require("@swc/helpers/_/_interop_require_default");
const _dayjs = /*#__PURE__*/ _interop_require_default._(require("dayjs"));
const _localizedFormat = /*#__PURE__*/ _interop_require_default._(require("dayjs/plugin/localizedFormat"));
const _dateconstants = require("./date.constants");
_dayjs.default.extend(_localizedFormat.default);
const DateFormat = {
    /**
   *
   * @param {DateInputType} start - The date instance that holds the range's start time
   * @param {DateInputType} end - The date instance that holds the range's end time
   * @return {string} Formatted date range, example: "8:30 AM-9:30 AM"
   */ hourRange (start, end) {
        const startString = DateFormat.hourMinute(start);
        const endString = DateFormat.hourMinute(end);
        return `${startString}${_dateconstants.EN_DASH}${endString}`;
    },
    /**
   *
   * @param {DateInputType} date - The date instance to format
   * @return {string} Formatted date, example: "Dec 7, 2020"
   */ date (date) {
        date = (0, _dayjs.default)(date);
        return date.format(_dateconstants.DATE_FORMAT);
    },
    /**
   *
   * @param {DateInputType} date - The date instance to format
   * @param {boolean} includeYear - Whether to include the year in the formatted date if the date is the current year
   * @return {string} Formatted date, example: "Dec 7, 2020, 8:59 PM" or "Dec 7, 8:59 PM"
   */ dateTime (date, includeYearIfCurrent) {
        date = (0, _dayjs.default)(date);
        const time = DateFormat.hourMinute(date);
        if (!includeYearIfCurrent && date.year() === (0, _dayjs.default)().year()) {
            return date.format(`${_dateconstants.DATE_FORMAT_NO_YEAR}, ${time}`);
        }
        const dateString = DateFormat.date(date);
        return `${dateString}, ${time}`;
    },
    /**
   *
   * @param {DateInputType} date - The date instance to format
   * @return {string} Formatted numeric date, example: "12/7/2020"
   */ dateNumeric (date) {
        date = (0, _dayjs.default)(date);
        return date.format(_dateconstants.DATE_NUMERIC_FORMAT);
    },
    /**
   *
   * @param {DateInputType} date - The date instance to format
   * @return {string} Formatted numeric date time, example: "12/7/2020, 8:59 PM"
   */ dateTimeNumeric (date) {
        date = (0, _dayjs.default)(date);
        const time = DateFormat.hourMinute(date);
        const dateString = DateFormat.dateNumeric(date);
        return date.format(`${dateString}, ${time}`);
    },
    /**
   *
   * @param {DateInputType} date - The date instance to format
   * @return {string} Formatted date, example: "Fri, Dec 7"
   */ shortDayMonthDate (date) {
        date = (0, _dayjs.default)(date);
        return date.format(_dateconstants.DATE_SHORT_FORMAT);
    },
    /**
   *
   * @param {DateInputType} date - The date instance to format
   * @return {string} Formatted date, example: "Friday, December 07"
   */ dayMonthDate (date) {
        date = (0, _dayjs.default)(date);
        return date.format(_dateconstants.DAY_MONTH_DATE_FORMAT);
    },
    /**
   *
   * @param {DateInputType} date - The date instance to format
   * @return {string} Formatted date, example: "Fri"
   */ shortDay (date) {
        date = (0, _dayjs.default)(date);
        return date.format(_dateconstants.DAY_SHORT_FORMAT);
    },
    /**
   *
   * @param {DateInputType} date - The date instance to format
   * @return {string} Formatted date, example: "8:59 AM"
   */ hourMinute (date) {
        date = (0, _dayjs.default)(date);
        return date.format(_dateconstants.TIME_FORMAT);
    },
    /**
   *
   * @param {DateInputType} date - The date instance to format
   * @return {string} Formatted Unix timestamp, example: "1360013296"
   */ timestamp (date) {
        date = (0, _dayjs.default)(date);
        return date.format(_dateconstants.UNIX_TIMESTAMP_FORMAT);
    },
    /**
   *
   * @param {DateInputType} date - The date instance to format
   * @return {string} Formatted date, example: "Dec 7"
   */ monthDate (date) {
        date = (0, _dayjs.default)(date);
        return date.format(_dateconstants.MONTH_DATE_FORMAT);
    },
    /**
   *
   * @param {DateInputType} date - The date to format
   * @param {DateInputType | undefined} today - The optional current day
   * @return {string} Formatted date, examples: "Today", "Tomorrow", "Yesterday", "12/7/2020"
   */ descriptiveDate (date, today) {
        date = (0, _dayjs.default)(date);
        today = today ? (0, _dayjs.default)(today) : (0, _dayjs.default)();
        if (date.isSame(today, 'day')) {
            return 'Today';
        }
        if (date.isSame(today.clone().subtract(1, 'day'), 'day')) {
            return 'Yesterday';
        }
        if (date.isSame(today.clone().add(1, 'day'), 'day')) {
            return 'Tomorrow';
        }
        return date.format('L');
    },
    /**
   *
   * @param date  - The date instance to format
   * @returns  - Formatted time, example: "59m ago", "2h ago", "3d ago"
   */ timeAgo (date) {
        date = (0, _dayjs.default)(date);
        const diffInMinutes = Math.floor(((0, _dayjs.default)().valueOf() - date.valueOf()) / 60000);
        const diffInHours = Math.floor(diffInMinutes / 60);
        const diffInDays = Math.floor(diffInHours / 24);
        if (diffInMinutes < 60) {
            return `${diffInMinutes}m ago`;
        }
        if (diffInHours < 24) {
            return `${diffInHours}h ago`;
        }
        return `${diffInDays}d ago`;
    }
};

//# sourceMappingURL=date.js.map